export function isValidHexColor(hex: string): boolean {
  // This regex matches the short form (#RGB), long form (#RRGGBB), and extended long form with alpha (#RRGGBBAA)
  const regex = /^#([0-9A-Fa-f]{3}){1,2}$|^#([0-9A-Fa-f]{4}){1,2}$/;
  return regex.test(hex);
}
